export default "/images/vendor/flag-icons/flags/1x1/pg.svg?730bb6bd6387a01d5c41d72af45beb71";